import { Injectable } from '@angular/core'
import { FormBuilder, FormControl, Validators } from '@angular/forms'

import COUNTRIES from '../../../assets/countries.json'
import { SignupFormProxy, SignupFormType } from './signup-form-proxy'

@Injectable({
  providedIn: 'root'
})
export class SignupFormFactory {
  private get _defaultCountry(): {} {
    return COUNTRIES.find((country) => country['name'] === 'United States of America')
  }

  public constructor(
    private _formBuilder: FormBuilder,
  ) {}

  public create(): SignupFormType {
    const signupForm = this._formBuilder.group({
      firstName: [null, [Validators.required, Validators.maxLength(50)]],
      lastName: [null, [Validators.required, Validators.maxLength(50)]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, this._passwordValidators()],
      zipCode: [null, [Validators.required, Validators.minLength(3)]],
      country: this._defaultCountry['code'],
      subscription: true
    })
    return new SignupFormProxy(signupForm) as SignupFormType
  }

  private _passwordValidators(): Validators[] {
    const atLeastOneCapitalLowerNumber = '^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).+$'
    return [Validators.minLength(6), Validators.pattern(atLeastOneCapitalLowerNumber)]
  }

  public createNewField(): FormControl {
    return new FormControl('', Validators.required)
  }
}
